import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import styles from './DropdownTabs.module.scss';
export function DropdownTabs({ tabs, activeId, onChange }) {
    const [internalActive, setInternalActive] = useState(activeId || (tabs[0] && tabs[0].id));
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);
    const currentActive = activeId !== null && activeId !== void 0 ? activeId : internalActive;
    const currentTab = tabs.find((t) => t.id === currentActive) || tabs[0];
    useEffect(() => {
        if (activeId) {
            setInternalActive(activeId);
        }
    }, [activeId]);
    // Đóng dropdown khi click ra ngoài
    useEffect(() => {
        function handleClickOutside(e) {
            if (!containerRef.current)
                return;
            if (!containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        }
        if (open) {
            document.addEventListener('click', handleClickOutside);
        }
        else {
            document.removeEventListener('click', handleClickOutside);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [open]);
    const handleSelect = (id) => {
        if (!activeId) {
            setInternalActive(id);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
        setOpen(false);
    };
    if (!currentTab)
        return null;
    return (h("div", { class: styles.dropdownTabs, ref: containerRef },
        h("button", { type: "button", class: styles.dropdownTrigger, onClick: () => setOpen((prev) => !prev), "aria-haspopup": "listbox", "aria-expanded": open },
            h("span", { class: `${styles.dropdownLabel} dropdown-label-preact` }, currentTab.label),
            h("span", { class: styles.dropdownIcon },
                h("svg", { width: "13", height: "7", viewBox: "0 0 13 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    h("path", { d: "M6.82945 6.82912L12.6626 0.995777C12.8905 0.768004 12.8905 0.398636 12.6626 0.170825C12.4348 -0.0569481 12.0655 -0.0569481 11.8377 0.170863L6.41692 5.59171L0.995913 0.170823C0.768101 -0.0569493 0.398773 -0.0569493 0.170961 0.170862C0.0570555 0.284729 0.000122051 0.434024 0.000122045 0.583319C0.000122038 0.732614 0.0570554 0.881908 0.171 0.995814L6.0045 6.82912C6.11389 6.93856 6.26226 7 6.41696 7C6.57166 7 6.72006 6.93856 6.82945 6.82912Z", fill: "#475360" })))),
        open && (h("ul", { class: styles.dropdownList, role: "listbox" }, tabs.map((tab) => (h("li", { key: tab.id },
            h("button", { type: "button", class: `${styles.dropdownItem} ${tab.id === currentActive ? styles.dropdownItemActive : ''}`, role: "option", "aria-selected": tab.id === currentActive, onClick: () => handleSelect(tab.id) }, tab.label))))))));
}
